<div class="wrapper">
  <h1 class="pageTitle">
    Thanks {{ client?.first_name }}! Your booking has been confirmed
  </h1>
  <app-notifications [notification]="'confirmation_page_notification_banner_child'"></app-notifications>
</div>
<div class="mb-5 text-center">
  <hr />
  <h2>
    Your reference number is <strong>{{ bookings?.id }}</strong>
  </h2>
  <hr />
</div>

<div class="container" id="container">
  <div class="page__main-content">
    <div class="bb-panel" *ngIf="selectedService">
      <div class="row panel-row-heading">
        <span class="section-heading col-sm-12">
          <strong>
            Your booking confirmation will be emailed to you shortly.
          </strong>
          <p class="bookHead">
            Please check your junk/spam folder if you do not receive your email.
          </p>
          <p class="bookHead">
            Please arrive within your booking slot, otherwise you may not be
            permitted access to the Recycling Centre.
          </p>
        </span>
      </div>
      <div class="row panel-row">
        <div class="col-sm-5">
          {{ 'CONFIRMATION.DATE_AND_TIME' | translate }}
        </div>
        <div class="col-sm-7">
          <p>{{ selectedSlot?.datetime | date : 'EEEE d MMMM yyyy' }}</p>
          <p>
            {{ selectedSlot?.datetime | date : 'HH:mm' }} -
            {{ endSlot | date : 'HH:mm' }}
          </p>
        </div>
      </div>
      <div class="row panel-row">
        <div class="col-sm-5">{{ 'CONFIRMATION.LOCATION' | translate }}</div>
        <div class="col-sm-7">
          <span>{{ address?.address1 }}, </span>
          <span *ngIf="address?.address2">{{ address?.address2 }}, </span>
          <span *ngIf="address?.address3">{{ address?.address3 }}, </span>
          <span *ngIf="address?.address4">{{ address?.address4 }}, </span>
          <span *ngIf="address?.address5">{{ address?.address5 }}, </span>
          {{ address?.postcode }}
        </div>
      </div>

      <div class="row panel-row">
        <div class="col-sm-5">Personal info</div>
        <div class="col-sm-7">
          {{ client.first_name }} {{ client.last_name }} <br />
          {{ client.email_address }}
          <br />
          <span *ngIf="client.mobile_number">0{{ client.mobile_number }}</span>
        </div>
      </div>
      <div class="row panel-row" *ngIf="registration">
        <div class="col-sm-5">Vehicle registration</div>
        <div class="col-sm-7">
          {{ registration }}
        </div>
      </div>
    </div>

    <div class="bb-panel" *ngIf="showMap">
      <app-leaflet-map [num]="2"></app-leaflet-map>
    </div>

    <div class="bb-panel" *ngIf="selectedService && total > 1">
      <div class="row panel-row-heading">
        <h2 class="section-heading col-sm-12">Your purchases</h2>
      </div>
      <div class="row panel-row">
        <div class="col-sm-7">item</div>
        <div class="col-sm-5">Price</div>
      </div>
      <div class="row panel-row">
        <div class="col-sm-7">{{ selectedService.name }}</div>
        <div class="col-sm-5">
          {{ selectedService.price / 100 | currency : 'GBP' : true }}
        </div>
      </div>

      <div *ngFor="let item of bookingSummaryData">
        <div class="row panel-row" *ngIf="item.detail_type === 'check-price'">
          <div class="col-sm-7">{{ item.name }}</div>
          <div class="col-sm-5">
            {{ item.price / 100 | currency : 'GBP' : true }}
          </div>
        </div>
      </div>

      <div class="row panel-row">
        <div class="col-sm-7"><strong>Total</strong></div>
        <div class="col-sm-5">{{ total / 100 | currency : 'GBP' : true }}</div>
      </div>
    </div>
  </div>

  <div class="page__main-content">
    <div class="button-navigation">
      <div class="row mt-4">
        <div class="col-6">
          <button type="button" class="btn btn-primary float-left" (click)="print()" title="Print" aria-label="Print">
            <span>
              <fa-icon [icon]="faPrint"></fa-icon><span>Print</span>
            </span>
          </button>
        </div>
        <div class="col-6">
          <button class="btn btn-primary float-right" type="button" (click)="goHome()" title="Return home"
            aria-label="Return home">
            <span>
              <span>Return home</span>
              <span style="padding-left: 25px">
                <fa-icon [icon]="faChevronRight"></fa-icon>
              </span>
            </span>
          </button>
        </div>
      </div>
    </div>
    <br />
    <br />
  </div>
</div>